const MAX_CARRIERS_FILTERS = 5;
const DETAILS_FILTERS_TO_SHOW = ['no-printer', 'cash-on-delivery'];

export { DETAILS_FILTERS_TO_SHOW, MAX_CARRIERS_FILTERS };
//# sourceMappingURL=filters.js.map
